import { Controller } from '@hotwired/stimulus'

// Cookie consent banner (LSSI-CE art. 22 / GDPR). The server renders the banner
// only when the `cookie_consent` cookie is absent, so this controller just needs
// to record the choice and remove the banner.
//
// Non-essential scripts (e.g. Google Analytics, once added) must NOT run until
// consent is "accepted". Gate them on `hasConsent('accepted')` on page load, and
// listen for the `cookie-consent:accepted` event to start them without a reload.
const COOKIE_NAME = 'cookie_consent'
const MAX_AGE_DAYS = 180

export default class extends Controller<HTMLElement> {
  accept(): void {
    this.dispatch('accepted') // -> "cookie-consent:accepted" (dispatch before removing
    this.record('accepted')   // the element, so the event still bubbles to document)
  }

  reject(): void {
    this.record('rejected')
  }

  private record(value: 'accepted' | 'rejected'): void {
    const maxAge = MAX_AGE_DAYS * 24 * 60 * 60
    const secure = window.location.protocol === 'https:' ? '; Secure' : ''
    document.cookie = `${COOKIE_NAME}=${value}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`
    this.element.remove()
  }
}
